
import ImageService from '@/services/ImageService'  
import GLTFService from '@/services/GLTFService' 
 
import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'

import { clamp, map, DEG_TO_RAD } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'
  
import BaseScene from '@/components/stage/common/base_scene'
import BubbleGroup from '@/components/stage/scene/home/bubble'
import BubbleFbo  from '@/components/stage/scene/home/bubble-fbo'
import CameraGroup from '@/components/stage/scene/home/camera'
import CharacterGroup from '@/components/stage/scene/home/character'
import FaceGroup from '@/components/stage/scene/home/character-face'
import TrianglesGroup from '@/components/stage/scene/home/triangles' 
 
import gsap from 'gsap'
import dat from 'dat.gui' 

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'

const Events = {
  ScrollLock : 'Events.ScrollLock'
}

class Scene extends BaseScene { 

  constructor(config) { 

    super(config) 

    this.Events = Events
    Object.assign(this, EventEmitter)

    this.options = { 
      parent: {
        position: {
          x: 0,
          y: 0,
          z: -0.5
        }
      },
      fog: {
        color: 0xFFFFFF, //0x545eba,
        near: 5,
        far: 8
      }
    }

    this.triangleOrderFront = false
    this.frame = 0
    this.tweenObj = {
      pulseSpeed: 0.01,
      opacityAmt: 0,
      opacity: 0.5
    }
 
    this.setup()
    this.resize() 
  }

  setup() {

    this.rTexture = new THREE.WebGLRenderTarget(window.innerWidth * Env.pixelRatio, window.innerHeight * Env.pixelRatio, {
      minFilter: THREE.LinearFilter, 
      magFilter: THREE.NearestFilter,   
      format: THREE.RGBAFormat 
    })
 
    // this.addGUI()
    this.setupViews()

    this.parent = new THREE.Object3D()
    this.add( this.parent )

    this.parent2 = new THREE.Object3D()
    this.parent.add( this.parent2 )

  }

  setupViews(){

    this.cameraGroup = new CameraGroup({ 
      gui : this.gui, 
      reduced_motion: this.reduced_motion 
    })
    this.add(this.cameraGroup)
    this.views.push(this.cameraGroup)

    this.bubble = new BubbleGroup({ 
      gui : this.gui, 
      textures: this.textures,
      reduced_motion: this.reduced_motion 
    })
    this.views.push(this.bubble)
 
    this.bubbleFbo = new BubbleFbo({ 
      renderer : this.renderer, 
      reduced_motion: this.reduced_motion 
    })
    this.views.push(this.bubbleFbo) 

    this.triangles = new TrianglesGroup({ 
      gui : this.gui,
      textures: this.textures,
      cameraGroup: this.cameraGroup,
      reduced_motion: this.reduced_motion
    })
    this.views.push(this.triangles)

    this.character = new CharacterGroup({ 
      gui : this.gui, 
      textures: this.textures,
      reduced_motion: this.reduced_motion
    })
    this.views.push(this.character)

    this.face = new FaceGroup({ 
      gui : this.gui, 
      textures: this.textures,
      renderer : this.renderer, 
      reduced_motion: this.reduced_motion
    })
    this.views.push(this.face)
 
  }

  setTrianglesToFront(){

    if(this.triangleOrderFront){
      return
    }

    this.parent.add( this.character.meshInside ) 
    this.parent.add( this.bubble )  
    this.parent.add( this.character.meshOuter )  
    this.parent.add( this.face ) 
    this.parent.add( this.triangles ) 

    this.triangleOrderFront = true
  }

  setTrianglesToBack(){

    if(!this.triangleOrderFront){
      return
    }

    this.parent.add( this.character.meshInside ) 
    this.parent.add( this.triangles )  
    this.parent.add( this.bubble )  
    this.parent.add( this.character.meshOuter ) 
    this.parent.add( this.face )

    this.triangleOrderFront = false
  }

  mainLoaded(  ){ 
    this.views.forEach( view => view.mainLoaded(  ) )   
  }

  bubbleLoaded(){ 
    this.views.forEach( view => view.bubbleLoaded() )  
    if(this.bubble){ 
      this.parent.add( this.bubble )
    } 
  }

  characterLoaded(){ 

    this.views.forEach( view => view.characterLoaded() )  

    // order important
    this.setTrianglesToFront()
  }

  loadComplete(){} 
 
 
  getCamera(){
    return this.cameraGroup.camera
  }
 
  // addGUI () {
  //   let parentFolder = this.gui.addFolder('Character / Bubble Parent')
  //   let parentPositionFolder = parentFolder.addFolder('position')
  //   parentPositionFolder.add(this.options.parent.position, 'x', -10, 10)
  //   parentPositionFolder.add(this.options.parent.position, 'y', -10, 10)
  //   parentPositionFolder.add(this.options.parent.position, 'z', -10, 10)

  //   let fogFolder = parentFolder.addFolder('fog')
  //   fogFolder.addColor(this.options.fog, 'color').onChange(()=>{ this.fog.color = new THREE.Color(this.options.fog.color) })
  //   fogFolder.add(this.options.fog, 'near', 0, 10).onChange(()=>{ this.fog.near = this.options.fog.near })
  //   fogFolder.add(this.options.fog, 'far',  0, 10).onChange(()=>{ this.fog.far = this.options.fog.far })
  // }

  updateGUI () {}

  pointerMove(event){   
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerMove(event)
    }
  }

  pointerStart(event){
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerStart(event)
    }   
  }

  pointerEnd(event){
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].pointerEnd(event)
    }
  }


  // UPDATES -------------------------------------------------------------------

 
  tick(dt, time) {

    
    this.frame += this.tweenObj.pulseSpeed
    let opacityOffset = ( Math.cos(this.frame) * this.tweenObj.opacityAmt )
    let pulseOpacity = this.tweenObj.opacity + opacityOffset
 
    for (var i = 0; i < this.views.length; i++) {
      this.views[i].tick(dt, time , pulseOpacity)
    }


    if(this.parent){
      this.parent.position.x = this.options.parent.position.x
      this.parent.position.y = this.options.parent.position.y
      this.parent.position.z = this.options.parent.position.z
    }
     
    if(this.cameraGroup && this.cameraGroup.camera){
      this.renderer.setRenderTarget( this.rTexture ) 
      //this.renderer.clear() 
      this.renderer.render( this, this.cameraGroup.camera )  
    } 
  }

  resize() {
    this.views.forEach( view => view.resize() ) 
    this.rTexture.setSize(window.innerWidth * Env.pixelRatio, window.innerHeight * Env.pixelRatio) 
    this.cameraGroup.resize()
  } 

  destroy(){} 

  enter(){ }

  leave(){ }



  // HANDLERS -------------------------------------------------------------------

  onClick(){

    var img = new Image();
    img.onload = () => {
      var $a = document.createElement('a')
      $a.download = 'nzta-screenshot.png'
      $a.href = img.src
      $a.click()
      this.renderer.preserveDrawingBuffer = false
      this.renderer.setClearColor(this.options.bgColor , 1) 
    } 

    this.renderer.setClearColor(this.options.bgColor , 0)
    this.renderer.preserveDrawingBuffer = true
    this.render()
    img.src = this.renderer.domElement.toDataURL("image/png")
     
  }



  // STATES -------------------------------------------------------------------

  /* modal states */
 
  modalNone(){ this.views.forEach( view => view.modalNone() ) }
  modalMenu(){ this.views.forEach( view => view.modalMenu() ) }


  /* home states */
 
  welcome(val, prev, dir){
    this.views.forEach( view => view.welcome(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.01, opacityAmt: 0 })
    this.setTrianglesToFront()
  } 
 
  ratingFive(val, prev, dir){ 
    this.views.forEach( view => view.ratingFive(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.01, opacityAmt: 0.1 })
    this.setTrianglesToFront()
  } 

  ratingFour(val, prev, dir){
    this.views.forEach( view => view.ratingFour(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.01, opacityAmt: 0.1 })
    this.setTrianglesToFront()
  } 
 
  ratingThree(val, prev, dir){
    this.views.forEach( view => view.ratingThree(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.05, opacityAmt: 0.1 })
    this.setTrianglesToFront()
  }

  ratingTwo(val, prev, dir){
    this.views.forEach( view => view.ratingTwo(val, prev, dir) ) 
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.075, opacityAmt: 0.13 })
    this.setTrianglesToFront()
  } 
 
  ratingOne(val, prev, dir){
    this.views.forEach( view => view.ratingOne(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.09, opacityAmt: 0.15 })
    this.setTrianglesToFront()
  } 

  cta(val, prev, dir){
    this.views.forEach( view => view.cta(val, prev, dir) )
    gsap.to(this.tweenObj, 1, { pulseSpeed: 0.001, opacityAmt: 0 })
    this.setTrianglesToBack()
  } 
}

export default Scene